import axiosInstance from "../api/axiosInstance.js";

// dieStatusAPI api's
export const dieStatusAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("DiaStatus/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`DiaStatus/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`DiaStatus/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`DiaStatus/GetAll`).then((res) => res.data),

  getAllDieStatus: async (page, size) =>
    axiosInstance
      .post("DiaStatus/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// supplierDieAPI api's
export const supplierDieAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Supplier/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Supplier/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Supplier/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Supplier/GetAll`).then((res) => res.data),

  getAllSupplier: async (page, size) =>
    axiosInstance
      .post("Supplier/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// locationAPI api's
export const locationAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Location/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Location/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Location/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Location/GetAll`).then((res) => res.data),

  getAllLocation: async (page, size) =>
    axiosInstance
      .post("Location/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// toolingSize api's
export const ToolingAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("ToolingSize/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`ToolingSize/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`ToolingSize/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`ToolingSize/GetAll`).then((res) => res.data),

  getAllLocation: async (page, size) =>
    axiosInstance
      .post("ToolingSize/GetAllPaged", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// dieType api's
export const DieTypeAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("DieType/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`DieType/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`DieType/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`DieType/GetAll`).then((res) => res.data),

  getAllLocation: async (page, size) =>
    axiosInstance
      .post("DieType/GetAllPaged", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// dieMasterAPI api's
export const dieMasterAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("Die/SaveOrUpdate", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Die/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Die/Delete/${id}`).then((res) => res.data),

  getAll: async () => axiosInstance.get(`Die/GetAll`).then((res) => res.data),
  getAllDieForBatches: async () =>
    axiosInstance.get(`Die/GetAllDieForBatches`).then((res) => res.data),

  getAllDieMaster: async (page, size) =>
    axiosInstance
      .post("Die/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllDieAllocation: async (page, size) =>
    axiosInstance
      .post("DieAllocation/GetAllAllocationData", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllOvenIssuedData: async (page, size) =>
    axiosInstance
      .post("DieAllocation/GetAllOvenIssuedData", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  sendToOven: async (payload) =>
    axiosInstance
      .post("DieAllocation/SendToOven", payload)
      .then((res) => res.data),

  diePDFDelete: async (id) =>
    axiosInstance.delete(`Die/RemoveFile/${id}`).then((res) => res.data),

  dieIMGDelete: async (id) =>
    axiosInstance.delete(`Die/RemoveImageFile/${id}`).then((res) => res.data),
};

// customerAPI api's
export const customerAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Customer/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Customer/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Customer/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Customer/GetAll`).then((res) => res.data),

  fetchGstNo: async (gst) =>
    axiosInstance
      .get(
        `https://powerful-gstin-tool.p.rapidapi.com/v1/gstin/${gst}/details`,
        {
          headers: {
            "X-RapidAPI-Key":
              "eefc9ebd2fmshd5c1b9191e93204p1a03fcjsn6d58d399aae4",
            "X-RapidAPI-Host": "powerful-gstin-tool.p.rapidapi.com",
          },
        },
      )
      .then((res) => res.data),

  getAllCustomer: async (page, size) =>
    axiosInstance
      .post("Customer/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// alloyAPI api's
export const alloyAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Alloy/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Alloy/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Alloy/Delete/${id}`).then((res) => res.data),

  getAll: async () => axiosInstance.get(`Alloy/GetAll`).then((res) => res.data),

  getAllAlloy: async (page, size) =>
    axiosInstance
      .post("Alloy/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// departmentAPI api's
export const departmentAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Department/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Department/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Department/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Department/GetAll`).then((res) => res.data),

  getAllDepartment: async (page, size) =>
    axiosInstance
      .post("Department/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// inchargeAPI api's
export const inchargeAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Incharge/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Incharge/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Incharge/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Incharge/GetAll`).then((res) => res.data),

  getAllIncharge: async (page, size) =>
    axiosInstance
      .post("Incharge/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// seriesAPI api's
export const seriesAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Series/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Series/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Series/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Series/GetAll`).then((res) => res.data),

  getAllSeries: async (page, size) =>
    axiosInstance
      .post("Series/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// orderStatusAPI api's
export const orderStatusAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("OrderStatus/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`OrderStatus/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`OrderStatus/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`OrderStatus/GetAll`).then((res) => res.data),

  getAllOrders: async (page, size) =>
    axiosInstance
      .post("OrderStatus/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// saleOrderI api's
export const salesOrderMaster = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("SalesOrder/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance
      .get(`SalesOrder/GetBySaleOrderId/${id}`)
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`SalesOrder/Delete/${id}`).then((res) => res.data),

  deleteOrderDetails: async (order_Detail_Id, orderNo) =>
    axiosInstance
      .delete(`SalesOrder/DeleteOrderDetail/${orderNo}/${order_Detail_Id}`)
      .then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`SalesOrder/GetAll`).then((res) => res.data),

  getAllOrders: async (page, size) =>
    axiosInstance
      .post("SalesOrder/GetAllSaleOrderWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  AddToBatch: async (data) =>
    axiosInstance.post("SalesOrder/AddToBatch", data).then((res) => res.data),

  SendToProdcution: async (data) =>
    axiosInstance
      .post("Production/InsertToProduction", data)
      .then((res) => res.data),
};

// order-plan API's
export const orderPlanView = {
  getAllPlanOrders: async (page, size) =>
    axiosInstance
      .post("SalesOrder/GetAllOrderWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getByPrintId: async (orderNo) =>
    axiosInstance
      .get(`SalesOrder/GenerateOrderPdf/${orderNo}`, {
        responseType: "blob",
      })
      .then((res) => res.data),

  getAllExecutedOrders: async (page, size) =>
    axiosInstance
      .post("SalesOrder/GetAllExecuteOrderNoWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// RawMaterial API's
export const rawMaterials = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("RawMaterial/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`RawMaterial/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`RawMaterial/GetAll`).then((res) => res.data),

  getAllRawMaterials: async (page, size) =>
    axiosInstance
      .post("RawMaterial/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`RawMaterial/Delete/${id}`).then((res) => res.data),

  getRawMaterialStock: async (categoryId) =>
    axiosInstance
      .get(`RawMaterial/RawMaterialStock/${categoryId}`)
      .then((res) => res.data),

  getAllStock: async () =>
    axiosInstance.get(`RawMaterial/GetStockGrouped`).then((res) => res.data),
};

// category API's
export const categories = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Category/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Category/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`Category/GetAll`).then((res) => res.data),

  getAllCategories: async (page, size) =>
    axiosInstance
      .post("Category/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Category/Delete/${id}`).then((res) => res.data),
};

// DieUnloadReasonAPI API's
export const DieUnloadReasonAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("DieUnloadReason/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`DieUnloadReason/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`DieUnloadReason/GetAll`).then((res) => res.data),

  getAllDieUnloadReason: async (page, size) =>
    axiosInstance
      .post("DieUnloadReason/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`DieUnloadReason/Delete/${id}`)
      .then((res) => res.data),
};

// materialInward API's
export const materialInward = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("MaterialInward/SaveOrUpdate", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`MaterialInward/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`MaterialInward/GetAll`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`MaterialInward/Delete/${id}`).then((res) => res.data),

  getAllmaterialInward: async (page, size) =>
    axiosInstance
      .post("MaterialInward/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllSKU: async () =>
    axiosInstance.get(`MaterialInward/GetAllSKU`).then((res) => res.data),
};

// Unit API's
export const Unit = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("UnitMaster/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`UnitMaster/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`UnitMaster/GetAll`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`UnitMaster/Delete/${id}`).then((res) => res.data),
};

// Spectro API's
export const SpectroCom = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("SpectroComponent/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`SpectroComponent/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`SpectroComponent/GetAll`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`SpectroComponent/Delete/${id}`)
      .then((res) => res.data),

  getAllSpectro: async (page, size) =>
    axiosInstance
      .post("SpectroComponent/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// Furnace API's
export const Furnace = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("FurnaceMaster/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`FurnaceMaster/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`FurnaceMaster/GetAll`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`FurnaceMaster/Delete/${id}`).then((res) => res.data),

  getAllFurnace: async (page, size) =>
    axiosInstance
      .post("FurnaceMaster/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// Press API's
export const Press = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("PressMaster/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`PressMaster/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`PressMaster/GetAll`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`PressMaster/Delete/${id}`).then((res) => res.data),

  getAllPress: async (page, size) =>
    axiosInstance
      .post("PressMaster/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),
};

// Foundry API's
export const foundry = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("Foundry/SaveFoundryEntry", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Foundry/GetByCastingNo/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`RawMaterial/GetAll`).then((res) => res.data),

  getAllFoundry: async (page, size) =>
    axiosInstance
      .post("Foundry/GetWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`Foundry/DeleteFoundryEntry/${id}`)
      .then((res) => res.data),

  deleteFinalSpectro: async (castingNo, seqNo) =>
    axiosInstance
      .delete(`Foundry/finalSpectro/${castingNo}/${seqNo}`)
      .then((res) => res.data),

  deleteSampleSpectro: async (castingNo, seqNo) =>
    axiosInstance
      .delete(`Foundry/sampleSpectro/${castingNo}/${seqNo}`)
      .then((res) => res.data),

  deleteScrap: async (castingNo, seqNo) =>
    axiosInstance
      .delete(`Foundry/scrap/${castingNo}/${seqNo}`)
      .then((res) => res.data),

  deleteChemical: async (castingNo, seqNo) =>
    axiosInstance
      .delete(`Foundry/chemical/${castingNo}/${seqNo}`)
      .then((res) => res.data),

  uploadSampleFile: async (formData) =>
    axiosInstance
      .post("Foundry/UploadSampleReport", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  uploadFinalFile: async (formData) =>
    axiosInstance
      .post("Foundry/UploadFinalReport", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),
};

//in-production API's
export const inProduction = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("Production/SaveOrUpdateProductionByBatch", data)
      .then((res) => res.data),

  saveBilletChange: async (data) =>
    axiosInstance.post("Production/BilletChange", data).then((res) => res.data),

  getAllInProduction: async (die_Id, page, size) =>
    axiosInstance
      .post("Production/GetAllProductionWithPagination", {
        die_Id: die_Id ?? 0,
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllInMarkDone: async (page, size) =>
    axiosInstance
      .post("Production/GetAllFinishedProductionWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  ProdStart: async (payload) =>
    axiosInstance
      .post("Production/StartProduction", payload)
      .then((res) => res.data),

  DiaUnload: async (payload) =>
    axiosInstance.post("Production/DieUnload", payload).then((res) => res.data),

  getById: async (id) =>
    axiosInstance
      .get(`Production/GetProductionByBatchId/${id}`)
      .then((res) => res.data),

  getAllCastingNo: async () =>
    axiosInstance.get(`Foundry/GetAllCastingNo`).then((res) => res.data),

  MarkProductionDone: async (data) =>
    axiosInstance
      .post("Production/MarkProductionDone", data)
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`Production/DeleteProduction/${id}`)
      .then((res) => res.data),
};

//qc API's
export const qc = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("QCEntry/SaveOrUpdate", data).then((res) => res.data),

  getById: async (batch_Id, casting_No, die_Id) =>
    axiosInstance
      .get(`QCEntry/GetById/${batch_Id}/${casting_No}/${die_Id}`)
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`QCEntry/Delete/${id}`).then((res) => res.data),

  getAllQC: async (page, size) =>
    axiosInstance
      .post("QCEntry/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  MarkQCDone: async (data) =>
    axiosInstance.post("QCEntry/MarkQcDone", data).then((res) => res.data),
};

//aging API's
export const aging = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Aging/SaveOrUpdateAging", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Aging/GetById/${id}`).then((res) => res.data),

  AddToAging: async (data) =>
    axiosInstance.post("Aging/AddToAging", data).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Aging/DeleteAging/${id}`).then((res) => res.data),

  agingDetailsDelete: async (id) =>
    axiosInstance.delete(`Aging/DeleteAging/${id}`).then((res) => res.data),

  getAllAging: async (page, size) =>
    axiosInstance
      .post("Aging/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllQcDone: async (page, size) =>
    axiosInstance
      .post("QCEntry/GetQCDoneWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  MarkAgingDone: async (data) =>
    axiosInstance.post("Aging/MarkAgingDone", data),

  getAllAgingBatch: async () =>
    axiosInstance.get(`Aging/GetAllBatchIds`).then((res) => {
      return res.data;
    }),

  getAllCastingByBatch: async (batch_Id) =>
    axiosInstance
      .get(`Aging/GetCastingNosByBatch/${batch_Id}`)
      .then((res) => res.data),

  getAllDieNoByCasting: async (casting_No) =>
    axiosInstance
      .get(`Aging/GetDieNumbersByCasting/${casting_No}`)
      .then((res) => res.data),
};

// packingEntry api's
export const packingEntryAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("PackingEntry/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`PackingEntry/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`PackingEntry/Delete/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`PackingEntry/GetAll`).then((res) => res.data),

  getAllDie: async (id) =>
    axiosInstance
      .get(`Die/GetAllDieNumberByOrderNo/${id}`)
      .then((res) => res.data),

  getAllAgingDone: async (page, size) =>
    axiosInstance
      .post("PackingEntry/GetAllIsAgingDone", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  AddToPacking: async (id) =>
    axiosInstance
      .get(`PackingEntry/AddToPacking/${id}`)
      .then((res) => res.data),

  getAllCutLength: async (orderNo, dieId) =>
    axiosInstance
      .get(`Die/GetCutLengthByOrderAndDie/${orderNo}/${dieId}`)
      .then((res) => res.data),

  getAllPackingEntry: async (page, size) =>
    axiosInstance
      .post("PackingEntry/GetAllPackingPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getAllOrderNo: async () =>
    axiosInstance.get(`SalesOrder/GetAllOrderNo`).then((res) => res.data),

  packingBundles: async (data) =>
    axiosInstance.post("PackingEntry/PrintSelectedBundles", data, {
      responseType: "blob",
    }),
};

// user API's
export const UsersAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("User/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`User/GetById/${id}`).then((res) => res.data),

  getAll: async () => axiosInstance.get(`User/GetAll`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("User/GetAllPaged", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`User/Delete/${id}`).then((res) => res.data),
};

// login API's
export const LoginAPI = {
  loginUser: async (UserName, EncryptPassword) => {
    const data = { UserName, EncryptPassword };
    return axiosInstance.post("User/Login", data).then((res) => res.data);
  },
};

// menu-master API's
export const MenuMasterAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("MenuMaster/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`MenuMaster/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`MenuMaster/GetAll`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("MenuMaster/GetAllPaged", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`MenuMaster/Delete/${id}`).then((res) => res.data),
};

// menu-permission API's
export const MenuPermissionAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("UserMenuPermission/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance
      .get(`UserMenuPermission/getByUserId/${id}`)
      .then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`UserMenuPermission/GetAll`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("UserMenuPermission/getAllWithMenuName", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`UserMenuPermission/deleteByUserId/${id}`)
      .then((res) => res.data),

  deleteMenuId: async (user_Id, menu_Id) =>
    axiosInstance
      .delete(`UserMenuPermission/delete/${user_Id}/${menu_Id}`)
      .then((res) => res.data),
};

// conversion API's
export const unitConversionAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("UnitConversion/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`UnitConversion/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`UnitConversion/GetAll`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("UnitConversion/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`UnitConversion/Delete/${id}`).then((res) => res.data),
};

// ToolingType API's
export const ToolingTypeAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("ToolingType/SaveOrUpdate", data)
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`ToolingType/GetById/${id}`).then((res) => res.data),

  getAll: async () =>
    axiosInstance.get(`ToolingType/GetAll`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("ToolingType/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`ToolingType/Delete/${id}`).then((res) => res.data),
};

// ToolingTypeEntry API's
export const ToolingTypeEntryAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance.post("Tooling/SaveOrUpdate", data).then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`Tooling/GetById/${id}`).then((res) => res.data),

  getAllPagination: async (page, size) =>
    axiosInstance
      .post("Tooling/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  delete: async (id) =>
    axiosInstance.delete(`Tooling/Delete/${id}`).then((res) => res.data),
};

// nalco Rate API's
export const NalcoRateAPI = {
  getAllIngotPrice: async () =>
    axiosInstance.get(`NalcoPrice/ingot-price`).then((res) => res.data),

  getNalcoPrice: async () =>
    axiosInstance.get("NalcoPrice/GetNalcoPrice").then((res) => res.data),

  getAllNalcoPrice: async () =>
    axiosInstance.get("NalcoPrice/GetAll").then((res) => res.data),
};

// DiePurchaseOrder API's
export const DiePurchaseOrderAPI = {
  saveOrUpdate: async (data) =>
    axiosInstance
      .post("DiePurchaseOrder/SaveOrUpdate", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  getById: async (id) =>
    axiosInstance.get(`DiePurchaseOrder/GetById/${id}`).then((res) => res.data),

  delete: async (id) =>
    axiosInstance
      .delete(`DiePurchaseOrder/Delete/${id}`)
      .then((res) => res.data),

  deleteDetail: async (poNo, trnNo) =>
    axiosInstance
      .delete(`DiePurchaseOrder/DeleteDetail/${poNo}/${trnNo}`)
      .then((res) => res.data),

  getAllWithPagination: async (page, size) =>
    axiosInstance
      .post("DiePurchaseOrder/GetAllWithPagination", {
        PageNumber: page,
        PageSize: size,
      })
      .then((res) => res.data),

  getNewSubDieNo: async (dieNo) =>
    axiosInstance
      .get(`DiePurchaseOrder/GetNewSubDieNo?dieNo=${dieNo}`)
      .then((res) => res.data),

  getDiePOItems: async (poNo) =>
    axiosInstance
      .get(`DiePurchaseOrder/GetDiePOItems/${poNo}`)
      .then((res) => res.data),

  getPendingInwardItems: async () =>
    axiosInstance
      .get("DiePurchaseOrder/GetPendingInwardItems")
      .then((res) => res.data),

  processInward: async (data) =>
    axiosInstance
      .post("DiePurchaseOrder/ProcessInward", data)
      .then((res) => res.data),

  generatePdf: async (poNo) =>
    axiosInstance
      .get(`DiePurchaseOrder/GenerateDiePoPdf/${poNo}`, {
        responseType: "blob",
      })
      .then((res) => res.data),
};
